<template>
  <div class='indexbox'>
    <nav-bar left-arrow :title="$t('聊天')" />
    <van-skeleton title avatar :row="5" v-if="!chaturl" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      chaturl: '',
    }
  },
  computed: {
    address() {
      if (this.local.get("token")) {
        return this.$store.state.wallet.account
      }
      return ""
    },
  },
  created() {
    this.get_info()
  },
  methods: {
    get_info() {
      this.$get({
        url: "/api/v1/user/info",
        loading: true,
        success: (res) => {
          const chat_id = res.data.chat_id
          this.getUrl(chat_id)
        },
        tip: () => { },
      })
    },
    getUrl(chat_id) {
      this.$get({
        url: "/api/v1/home",
        success: (res) => {
          window.location.href = `${res.data.chat_url}?account=${chat_id}&password=${this.address}`
          // this.chaturl = `${res.data.chat_url}?account=${chat_id}&password=${this.address}`
          // this.$dialog.alert({
          //   title: this.$t('提示'),
          //   message: this.$t('请复制聊天链接，在手机默认浏览器中打开使用！'),
          //   confirmButtonText: this.$t('复制')
          // }).then(() => {
          //   this.copyData(this.chaturl)
          //   setTimeout(() => {
          //     this.$router.go(-1)
          //   }, 50);
          // });
        },
        tip: () => { },
      })
    }
  },
}
</script>
<style lang='less' scoped>
.indexbox {
  width: 100%;
  padding: 15px;
}
</style>